module.exports = __webpack_public_path__ + "img/ic_notification_shift.14a40160.svg";